import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fcf24480"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "image-modal__top-block-title" }
const _hoisted_3 = { class: "image-modal__img-carousel" }

import { useAppStore } from '@/store/modules/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageModal',
  props: /*#__PURE__*/_mergeModels({
    images: {},
    title: {},
    phone: {}
  }, {
    "modelValue": { type: Boolean },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;
// eslint-disable-next-line no-undef
const showImageModal = _useModel<boolean>(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  const _component_base_image = _resolveComponent("base-image")!
  const _component_base_image_gallery = _resolveComponent("base-image-gallery")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    fullScreen: _unref(useAppStore)().getWindowWidth() < 600,
    "show-modal": showImageModal.value,
    "show-padding": false,
    "close-outside": "",
    onClose: _cache[0] || (_cache[0] = ($event: any) => (showImageModal.value = false))
  }, {
    title: _withCtx(() => [
      _renderSlot(_ctx.$slots, "title"),
      (!_ctx.$slots.title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.title), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_base_image_gallery, {
          navigation: true,
          "slides-group": [{ id: 'modalImageSlides', title: '', slides: _ctx.images }],
          "space-between": 5
        }, {
          item: _withCtx((itemProps) => [
            _createVNode(_component_base_image, {
              name: String(itemProps),
              src: itemProps.data.item,
              "border-radius": "",
              class: "image-modal__img-carousel-item-img",
              contain: "",
              height: "100%",
              width: "100%"
            }, null, 8, ["name", "src"])
          ]),
          _: 1
        }, 8, ["slides-group"])
      ])
    ]),
    "bottom-box": _withCtx(() => [
      _renderSlot(_ctx.$slots, "bottom-box")
    ]),
    _: 3
  }, 8, ["fullScreen", "show-modal"]))
}
}

})